module.exports = __webpack_public_path__ + "ae2b658afe53f7959df2f9b69ee4c195.jpg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../images/speakers/small/maja-wichrowska.jpg
// module id = 670
// module chunks = 0